import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MediaUpload from '@src/components/MediaUpload';

export default function ClientItem({ setLogo, item, itemDisabled, onChange, removeItem, addItem, addDisabled }) {
  return (
    <div className={classnames('clients-list-item', itemDisabled && 'client-item-disabled')}>
      <MediaUpload
        className="clients-list-logo"
        disabled={itemDisabled}
        file={item.logo}
        height={512}
        keepFile
        onRemove={() => removeItem(item)}
        onUpload={image => onChange('logo', { ...image, url: image.fullUrl })}
        single
        titleSize="XS"
        width={512}
      />
    </div>
  );
}

ClientItem.propTypes = {
  addDisabled: PropTypes.bool,
  addItem: PropTypes.func,
  item: PropTypes.object,
  itemDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  removeItem: PropTypes.func,
  setLogo: PropTypes.func,
};
